var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSatisfactionSurveyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32703 5.12153C6.43196 4.2416 7.7629 3.69155 9.16666 3.53467V11.8222H17.4542C17.2973 13.2259 16.7472 14.5569 15.8673 15.6618C14.9874 16.7667 13.8133 17.6008 12.4803 18.0679C11.1473 18.535 9.70946 18.6162 8.3323 18.3022C6.95514 17.9882 5.69463 17.2918 4.69585 16.293C3.69706 15.2942 3.00058 14.0337 2.68659 12.6565C2.37259 11.2794 2.45382 9.84154 2.92095 8.50852C3.38807 7.1755 4.22209 6.00146 5.32703 5.12153Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.48886H17.0733C16.6992 7.43437 16.0946 6.47665 15.3034 5.68548C14.5122 4.89431 13.5545 4.28963 12.5 3.91553V8.48886Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfactionSurveyIcon);
export default __webpack_public_path__ + "static/media/satisfaction-survey-icon.5c1477527fc51b4395e6c6176c5fe5a6.svg";
export { ForwardRef as ReactComponent };